import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddUserLayer from "../components/AddUserLayer";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from 'react-select'
import { Link, useParams } from "react-router-dom";
import { API_URL } from "..";
const ViewScheduleMaintenance = () => {
    const {id} = useParams();
  const [status, setStatus] = useState(''); // 'resolved' or 'not-resolved'


  const [selectTruck, setSelectTruck] = useState({});
  const [formData, setFormData] = useState({
    service_date:'',
    service_description:'',
    cost:'',
    issueResolved:'Yes'
  });
const fetchSingleMaintenance = async () =>{
    const user = JSON.parse(localStorage.getItem('user'));
    let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }

       let response = await fetch(API_URL+`/api/maintenance/issue/single-record/${id}`, { 
         method: "GET",
         headers: headersList
       });
       let data = await response.json();
  
      setFormData(data)
      if(data.status == 'not_resolved'){
          setStatus('not_now');
        }else{
            setStatus('resolved');
        }
}
React.useEffect(()=>{
  fetchSingleMaintenance()
},[1])
const clickDeleteMaintenance = async () =>{
    const user = JSON.parse(localStorage.getItem('user'));
    let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }

       let response = await fetch(API_URL+`/api/maintenance/delete/single-issues/${id}`, { 
         method: "POST",
         headers: headersList
       });
       if(response.status === 200){
        window.location.href='/issue-reported';
       }else{
        alert('Server Problem')
       }

}
function formatDate(dateString) {
    // Parse the date string into a Date object
    const date = new Date(dateString);

    // Define an array of month names
    const months = [
        "January", "February", "March", "April", "May", "June", 
        "July", "August", "September", "October", "November", "December"
    ];

    // Extract day, month, and year from the Date object
    const day = date.getUTCDate(); // Use getUTCDate for consistent UTC handling
    const month = months[date.getUTCMonth()]; // getUTCMonth returns zero-based index
    const year = date.getUTCFullYear();

    // Format the string
    return `${day} ${month?.slice(0,3)} ${year}`;
}
const clickupdateMaintenance  = () =>{
    alert('under dev')
}
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Edit Schedule Maintenance" />

        {/* AddUserLayer */}
        <div className="card h-100 p-0 radius-12">
          <div className="card-body p-24">
            <div className="row justify-content-start">
              <div className="col-xxl-6 col-xl-8 col-lg-10">
                
                  
                   
                    {/* Upload Image Start */}

                    {/* Upload Image End */}
                    <div >
                    

                      <div className="mb-20">
                        <label
                          htmlFor="assigned_to"
                          className="form-label mb-20 fw-semibold text-primary-light text-sm mb-8"
                        >
                           Truck Information
                         
                        </label>
                        <div className="row">
                            <div className="col-md-4">
                            <strong>Vehicle Info</strong>
                            <p>{formData?.driver?.truck?.name}</p>
                            </div>
                            <div className="col-md-4">
                            <strong>Driver Name</strong>
                            <p>{formData?.driver?.first_name}</p>
                            </div>
                            <div className="col-md-4">
                            <strong>Driver Phone</strong>
                            <p>{formData?.driver?.phone_number}</p>
                            </div>
                           
                        </div>
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="email"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                        Maintenance Information
                        </label>
                      
                      </div>
                      
                      <div className="row">
                            <div className="col-md-12">
                            <strong>Title</strong>
                            <p>{formData?.title}</p>
                            </div>
                            <div className="col-md-12">
                            <strong>Description</strong>
                            <p>{formData?.description}</p>
                            </div>
                          
                            <div className="col-md-4">
                            <strong>Service Date</strong>
                            <p>{formData?.service_date}</p>
                            </div>
                           
                        </div>
                    </div>
                  
                
              </div>
              <div className="col-xxl-6 col-xl-8 col-lg-10" style={{
                display:'flex',
                justifyContent:'center',
                alignItems:'center'
                
              }}> 
                
                  
                   
                    {/* Upload Image Start */}

                    {/* Upload Image End */}
          
                    <div className="stamp-container">
                        {
                            status  == 'resolved' ?
                            <div className="stamp-error">Resolved</div>
                           : <div className="stamp">Not Resolved</div>

                        }
                        </div>
                    </div>
                  
                
                    <div className="col-xxl-12 col-xl-12 col-lg-12 ">

                        {
                             status == 'resolved' ? <Link  className="btn btn-success"><i className="ph ph-check"></i>Already Schedule Maintenance</Link> 
                       : <Link to={`/create-issue-schedule-maintenance/${id}`} className="btn btn-info"><i className="ph ph-pen"></i> Schedule Maintenance</Link> 
                        }
                        &nbsp;&nbsp;
                        <button onClick={()=>clickDeleteMaintenance()} className="btn btn-danger"><i className="ph ph-trash"></i> Remove</button>
                    </div>
            </div>
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default ViewScheduleMaintenance;
